import React from 'react'
import {Outlet, useNavigate} from 'react-router-dom'

import {ReportsSidebarNav} from './ReportsSidebarNav'

import {Layout} from '~/components/layout/Layout'

export const ReportsManagementPage = () => {
  const navigate = useNavigate()
  const fullPath = '/app/reports/'

  return (
    <Layout
      fullWidth
      sideNav={
        <ReportsSidebarNav
          fullPath={fullPath}
          onClick={(id) => navigate(`${fullPath}${id}`)}
        />
      }
      navMenu={null}>
      <Outlet />
    </Layout>
  )
}
